import { render, staticRenderFns } from "./ProductPopup.vue?vue&type=template&id=f9b34822&scoped=true"
import script from "./ProductPopup.vue?vue&type=script&lang=js"
export * from "./ProductPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b34822",
  null
  
)

export default component.exports